module.exports = __webpack_public_path__ + "static/media/galaxy.3638ec79.jpg";